var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('newBanner'),_c('newSpell'),_c('newInfo'),_c('myService'),_c('newOcean'),_c('newContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }